// extracted by mini-css-extract-plugin
export default {"listContainer":"PatientSelectionPage_listContainer__B5xgn"};